import {DriverLicenseDetails} from "./DriverLicenseDetails";

export class PrimaryDriver {
  public planHolder: boolean = null;
  public firstName: string = null;
  public surname: string = null;
  public cellphoneNumber: string = null;
  public legalRefTypeCd: number = null;
  public legalRefValue: string = null;
  public dateOfBirth?: string = null;
  public gender?: string = null;
  public emailAddress: string = null;
  public driverLicenseDetail: DriverLicenseDetails = new DriverLicenseDetails();
  public yearsAtPreviousInsurerCd: string = null;
  public consentGiven: boolean = null;

  constructor() {
  }

}
